export default "__VITE_PUBLIC_ASSET__b11373a0__"